import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchVouchers,
  SearchVouchersVariables
} from "./types/SearchVouchers";

export const searchVouchers = gql`
  ${pageInfoFragment}
  query SearchVouchers($after: String, $first: Int!, $query: String!) {
    search: vouchersByLanguage(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          name
          code
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export default makeTopLevelSearch<SearchVouchers, SearchVouchersVariables>(
  searchVouchers
);
